import { parsePhoneNumberFromString } from "libphonenumber-js";
import { AxiosClient } from "@/app/shared/services";
import settings from "@/environment";

const state = {
    registration: {
        form: {
            name: {
                value: "",
                percent: 10,
            },
            surname: {
                value: "",
                percent: 10,
            },
            second_name: {
                value: "",
                percent: 10,
            },
            phone: {
                value: "",
                percent: 15,
            },
            email: {
                value: "",
                percent: 10,
            },
            birthday: {
                value: "",
                percent: 5,
            },
            address: {
                value: "",
                percent: 15,
            },
            password: {
                value: "",
                show: false,
            },
            confirmPassword: {
                value: "",
                show: false,
            },
            passport: {
                value: "",
                percent: 15,
            },

            vendorConfirm: true,
            subscriptionConfirm: true,
        },
        _phone: {
            number: "",
            operator: "",
            isOperatorChecking: false,
            info: {},
        },
        _address: {
            isLoading: false,
            hints: [],
        },
        utm: {
            utm_campaign: localStorage.getItem("utm_campaign") || "",
            utm_content: localStorage.getItem("utm_content") || "",
            utm_medium: localStorage.getItem("utm_medium") || "",
            utm_source: localStorage.getItem("utm_source") || "",
            utm_term: localStorage.getItem("utm_term") || "",
            pxlid: localStorage.getItem("pxlid") || "",
            vkid: localStorage.getItem("vkid") || "",
        },
        affSubs: {
            aff_sub1: localStorage.getItem("aff_sub1") || "",
            aff_sub2: localStorage.getItem("aff_sub2") || "",
            aff_sub3: localStorage.getItem("aff_sub3") || "",
            aff_sub4: localStorage.getItem("aff_sub4") || "",
            aff_sub5: localStorage.getItem("aff_sub5") || "",
        },
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        possibility: parseInt(localStorage.getItem("loanPossibility")) || 0,
        loanvalue: settings.default_loanvalue,
        default_possibility: settings.default_possibility,
        min_default_possibility: settings.min_default_possibility,
        max_default_possibility: settings.max_default_possibility,
        default_loanvalue: settings.default_loanvalue,
        min_default_loanvalue: settings.min_default_loanvalue,
        max_default_loanvalue: settings.max_default_loanvalue,
    },
    creditionals: {
        user: null,
        uuid: localStorage.getItem("profileUUID") || "",
        apiKey: localStorage.getItem("profileAPIKey") || "",
    },
    validation: {
        phone: {
            isOpen: false,
            isCodeSent: false,
            isVerificated: false,
            isLoading: false,
        },
    },
    modals: {
        personal_data: false,
        user_terms: false,
        personal_data_text: "",
        user_terms_text: "",
    },
};

const getters = {
    GET_REGISTRATION_CREDITIONALS: (state) => state.registration.form,
    GET_PHONE_NUMBER_OPERATOR: (state) => state.registration._phone.operator,
    GET_PHONE_NUMBER: (state) =>
        parsePhoneNumberFromString(state.registration.form.phone.value, process.env.VUE_APP_LOCAL),
    GET_ADDRESS_HINT_LOADING: (state) => state.registration._address.isLoading,
    GET_ADDRESS_HINT: (state) => state.registration._address.hints,
    REGISTRATION_IS_SUCCESS: (state) => state.registration.isSuccess,
    REGISTRATION_IS_LOADING: (state) => state.registration.isLoading,
    LOAN_POSSIBILITY: (state) => state.registration.possibility,
    LOAN_VALUE: (state) => state.registration.loanvalue,
    START_LOAN_POSSIBILITY: (state) => {
        if (state.registration.loanvalue == state.registration.default_loanvalue) {
            return state.registration.default_possibility;
        }
        if (state.registration.loanvalue < state.registration.default_loanvalue) {
            const step =
                (state.registration.default_loanvalue - state.registration.min_default_loanvalue) /
                (state.registration.max_default_possibility -
                    state.registration.default_possibility);
            return (
                state.registration.max_default_possibility -
                Math.trunc(
                    (state.registration.loanvalue - state.registration.min_default_loanvalue) / step
                )
            );
        }

        if (state.registration.loanvalue > state.registration.default_loanvalue) {
            const step =
                (state.registration.max_default_loanvalue - state.registration.default_loanvalue) /
                (state.registration.default_possibility -
                    state.registration.min_default_possibility);
            return (
                state.registration.min_default_possibility +
                Math.trunc(
                    (state.registration.max_default_loanvalue - state.registration.loanvalue) / step
                )
            );
        }
    },

    GET_UTM: (state) => state.registration.utm,
    GET_AFF_SUBS: (state) => state.registration.affSubs,

    GET_REGISTRATED_USER: (state) => state.creditionals.user,
    GET_REGISTRATED_USER_UUID: (state) => state.creditionals.uuid,
    GET_REGISTRATED_USER_APIKEY: (state) => state.creditionals.apiKey,

    IS_PHONE_VALIDATION_OPENED: (state) => state.validation.phone.isOpen,
    IS_PHONE_VALIDATION_LOADING: (state) => state.validation.phone.isLoading,
    IS_PHONE_VERIFICATED: (state) => state.validation.phone.isVerificated,

    IS_PERSONAL_DATA_MODAL_OPENED: (state) => state.modals.personal_data,
    IS_USER_TERMS_MODAL_OPENED: (state) => state.modals.user_terms,
    PERSONAL_DATA_MODAL_TEXT: (state) => state.modals.personal_data_text,
    USER_TERMS_MODAL_TEXT: (state) => state.modals.user_terms_text,
    IS_REGISTERED: (state) => state.registration.isRegistered,
};

const mutations = {
    SET_PHONE_NUMBER: (state, number) => (state.registration._phone.number = number),
    SET_PHONE_NUMBER_INFO: (state, info) => (state.registration._phone.info = info),
    SET_PHONE_NUMBER_OPERATOR: (state, operator) => (state.registration._phone.operator = operator),
    SET_PHONE_NUMBER_OPERATOR_CHECKING: (state, isChecking) =>
        (state.registration._phone.isOperatorChecking = isChecking),
    SET_ADDRESS_HINT_LOADING: (state, isLoading) =>
        (state.registration._address.isLoading = isLoading),
    SET_ADDRESS_HINTS: (state, hints) => (state.registration._address.hints = hints),
    SET_LOAN_POSSIBILITY: (state, possibility) => (state.registration.possibility = possibility),
    SET_LOAN_VALUE: (state, value) => (state.registration.loanvalue = value),

    SET_REGISTRATION_LOADING: (state, isLoading) => (state.registration.isLoading = isLoading),
    SET_IS_REGISTERED: (state, isRegistered) => (state.registration.isRegistered = isRegistered),
    SET_EMAIL_VERIFICATION_LOADING: (state, isLoading) =>
        (state.registration.isLoading = isLoading),
    SET_REGISTRATION_IS_SUCCESS: (state, isSuccess) => (state.registration.isSuccess = isSuccess),
    SET_UTM: (state, utm) => {
        if (utm.utm_campaign) state.registration.utm.utm_campaign = utm.utm_campaign;
        if (utm.utm_content) state.registration.utm.utm_content = utm.utm_content;
        if (utm.utm_medium) state.registration.utm.utm_medium = utm.utm_medium;
        if (utm.utm_source) state.registration.utm.utm_source = utm.utm_source;
        if (utm.utm_term) state.registration.utm.utm_term = utm.utm_term;
        if (utm.pxlid)  state.registration.utm.pxlid = utm.pxlid;
        if (utm.vkid) state.registration.utm.vkid = utm.vkid;
    },
    SET_AFF_SUBS: (state, affSubs) => {
        if (affSubs.aff_sub1) state.registration.affSubs.aff_sub1 = affSubs.aff_sub1;
        if (affSubs.aff_sub2) state.registration.affSubs.aff_sub2 = affSubs.aff_sub2;
        if (affSubs.aff_sub3) state.registration.affSubs.aff_sub3 = affSubs.aff_sub3;
        if (affSubs.aff_sub4) state.registration.affSubs.aff_sub4 = affSubs.aff_sub4;
        if (affSubs.aff_sub5) state.registration.affSubs.aff_sub5 = affSubs.aff_sub5;
    },

    SET_USER_UUID: (state, uuid) => (state.creditionals.uuid = uuid),
    SET_USER_APIKEY: (state, apiKey) => (state.creditionals.apiKey = apiKey),
    SET_USER_CREDITIONALS: (state, creditionals) => (state.creditionals.user = creditionals),

    SET_PHONE_VALIDATION_OPEN: (state, isOpen) => (state.validation.phone.isOpen = isOpen),
    SET_PHONE_VERIFICATED: (state) => {
        state.validation.phone.isVerificated = true;
        if (state.creditionals.user) state.creditionals.user.is_phone_confirm = true;
    },
    SET_PHONE_VERIFICATION_CODE_SENT: (state, isSent) =>
        (state.validation.phone.isCodeSent = isSent),
    SET_PHONE_VERIFICATION_LOADING: (state, isLoading) =>
        (state.validation.phone.isLoading = isLoading),

    SET_PERSONAL_DATA_MODAL_IS_OPENED: (state, isOpen) => (state.modals.personal_data = isOpen),
    SET_USER_TERMS_MODAL_IS_OPENED: (state, isOpen) => (state.modals.user_terms = isOpen),
    SET_PERSONAL_DATA_MODAL_TEXT: (state, text) => (state.modals.personal_data_text = text),
    SET_USER_TERMS_MODAL_TEXT: (state, text) => (state.modals.user_terms_text = text),
};

const actions = {
    GET_PERSONAL_AND_USER_TERMS_TEXTS: (context) => {
        return new Promise((resolve, reject) => {
            const lang = process.env.VUE_APP_LOCALE;
            AxiosClient.get("/profile/personal_and_user_texts", { params: { lang } })
                .then((response) => {
                    context.commit("SET_PERSONAL_DATA_MODAL_TEXT", response.data.personal_terms);
                    context.commit("SET_USER_TERMS_MODAL_TEXT", response.data.user_terms);
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {});
        });
    },

    GET_PHONE_NUMBER_INFO: (context) => {
        const info = parsePhoneNumberFromString(
            state.registration.form.phone.value,
            process.env.VUE_APP_LOCAL
        );
        context.commit("SET_PHONE_NUMBER_INFO", info);
        return info;
    },

    CHECK_OPERATOR: (context, form) => {
        if (form && form.phone && form.phone.valid) {
            context.dispatch("GET_PHONE_NUMBER_INFO");
            const phone = context.state.registration.form.phone.value.replace(/\D/g, "");
            if (
                context.state.registration._phone.info &&
                context.state.registration._phone.info.isValid() &&
                !context.state.registration._phone.isOperatorChecking &&
                context.state.registration._phone.number != phone
            ) {
                context.commit("SET_PHONE_NUMBER", phone);
                context.commit("SET_PHONE_NUMBER_OPERATOR_CHECKING", true);
                return new Promise((resolve, reject) => {
                    const params = { phone };
                    AxiosClient.get("/registration/operator", { params })
                        .then((resp) => {
                            const { operator } = resp.data;
                            context.commit("SET_PHONE_NUMBER_OPERATOR", operator);
                            resolve(operator);
                        })
                        .catch(() => {
                            context.commit("SET_PHONE_NUMBER_OPERATOR", undefined);
                            reject();
                        })
                        .finally(() => {
                            context.commit("SET_PHONE_NUMBER_OPERATOR_CHECKING", false);
                        });
                });
            }
        }
        return Promise.resolve();
    },

    GET_ADDRESS_HINT: (context, value) =>
        new Promise((resolve, reject) => {
            context.commit("SET_ADDRESS_HINT_LOADING", true);
            AxiosClient.get("/registration/address_hint", { params: { query: value } })
                .then((resp) => {
                    if (resp.data && resp.data.hasOwnProperty("suggestions")) {
                        const suggestions = resp.data.suggestions.map((address) => address.value);
                        context.commit("SET_ADDRESS_HINTS", suggestions);
                        resolve(suggestions);
                    }
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_ADDRESS_HINT_LOADING", false);
                });
        }),

    SET_LOAN_POSSIBILITY: (context, possibility) => {
        context.commit("SET_LOAN_POSSIBILITY", possibility);
        localStorage.setItem("loanPossibility", possibility);
    },

    SET_LOAN_VALUE: (context, value) => {
        context.commit("SET_LOAN_VALUE", value);
    },

    SET_REGISTERED : (context, isRegistered) => {
        context.commit("SET_IS_REGISTERED", isRegistered);
    },

    REGISTRATE: (context) => {
        context.commit("SET_REGISTRATION_LOADING", true);
        const creditionals = {};
        for (const [key, data] of Object.entries(context.state.registration.form)) {
            if (data && data.value) creditionals[key] = data.value;
        }
        const params = Object.assign({}, creditionals, context.state.registration.affSubs, context.state.registration.utm);
        params.phone = params.phone.replace(/\D+/g, "");
        params.birthday = context.state.registration.form.birthday.ISOFormatted;

        return new Promise((resolve, reject) => {
            AxiosClient.post("/profile/registration", params)
                .then((data) => {
                    const response = data.data;
                    if (response && response.uuid) {
                        context.commit("SET_REGISTRATION_IS_SUCCESS", true);
                        context.commit("SET_IS_REGISTERED", true);
                        context.commit("SET_USER_CREDITIONALS", response);
                        context.commit("SET_USER_UUID", response.uuid);
                        context.commit("SET_USER_APIKEY", response.api_key);
                        localStorage.setItem("profileUUID", response.uuid);
                        localStorage.setItem("profileAPIKey", response.api_key);
                    }
                    resolve(response);
                })
                .catch((error) => {
                    context.commit("SET_REGISTRATION_IS_SUCCESS", false);
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_REGISTRATION_LOADING", false);
                });
        });
    },

    OPEN_PHONE_VALIDATION: (context) => {
        context.commit("SET_PHONE_VALIDATION_OPEN", true);
    },

    PERSONAL_DATA_MODAL: (context, isOpen) => {
        context.commit("SET_PERSONAL_DATA_MODAL_IS_OPENED", isOpen);
    },

    USER_TERMS_MODAL: (context, isOpen) => {
        context.commit("SET_USER_TERMS_MODAL_IS_OPENED", isOpen);
    },

    SEND_PHONE_VERIFICATION_CODE: (context) => {
        let { phone } = context.state.creditionals.user;
        const { uuid } = context.state.creditionals.user;
        phone = phone.replace(/\D+/g, "");
        if (phone && uuid) {
            context.commit("SET_PHONE_VERIFICATION_LOADING", true);
            return new Promise((resolve, reject) => {
                AxiosClient.post("/profile/verificate_phone", { phone, uuid })
                    .then((data) => {
                        context.commit("SET_PHONE_VERIFICATION_CODE_SENT", true);
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        context.commit("SET_PHONE_VERIFICATION_LOADING", false);
                    });
            });
        }

        return Promise.reject();
    },

    CHECK_VERIFICATION_CODE: (context, code) => {
        let { phone } = context.state.creditionals.user;
        const { uuid } = context.state.creditionals.user;
        phone = phone.toString().replace(/\D+/g, "");
        if (phone && uuid && code) {
            context.commit("SET_PHONE_VERIFICATION_LOADING", true);
            return new Promise((resolve, reject) => {
                AxiosClient.post("/profile/check_verification_code", { phone, uuid, code })
                    .then((data) => {
                        context.commit("SET_PHONE_VERIFICATED", true);
                        context.commit("SET_PHONE_VALIDATION_OPEN", false);
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        context.commit("SET_PHONE_VERIFICATION_LOADING", false);
                    });
            });
        }
        return Promise.reject();
    },

    SEND_EMAIL_VERIFICATION_CODE: (context) => {
        const { email, uuid } = context.state.creditionals.user;
        if (email && uuid) {
            context.commit("SET_EMAIL_VERIFICATION_LOADING", true);
            return new Promise((resolve, reject) => {
                AxiosClient.post("/profile/verificate_email", { uuid, email })
                    .then((data) => {
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        context.commit("SET_EMAIL_VERIFICATION_LOADING", false);
                    });
            });
        }

        return Promise.reject();
    },

    GET_USER_CREDENTIALS_BY_APIKEY: (context, apiKey) => {
        context.commit("SET_REGISTRATION_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.get("/profile/loginbyapikey", { params: { api_key: apiKey } })
                .then((response) => {
                    context.commit("SET_USER_CREDITIONALS", response.data);
                    resolve(response.data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_REGISTRATION_LOADING", false);
                });
        });
    },

    COMPLETE_REGISTRATION: (context) => {
        context.commit("SET_REGISTRATION_LOADING", true);
        return new Promise((resolve, reject) => {
            AxiosClient.post("/profile/complete_registration", {
                uuid: context.state.creditionals.user.uuid,
            })
                .then(() => {
                    localStorage.removeItem("profileUUID");
                    localStorage.removeItem("profileAPIKey");
                    resolve(context.state.creditionals.user);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit("SET_REGISTRATION_LOADING", false);
                });
        });
    },
    AUTO_REGISTER: (context, query) => {
        context.commit("SET_REGISTRATION_LOADING", true);
        let creditionals = {
            phone: query.phone,
            email: query.phone + "@mail.ru",
            password: "default_password",
        };
        let utm = {
            utm_source: query.utm_source,
        };
        context.commit("SET_UTM", utm);
        let params = Object.assign({}, creditionals, state.registration.utm, {
            phone_confirmed: true,
        });
        return new Promise((resolve, reject) => {
            AxiosClient.post("/profile/auto_register", params)
                .then((data) => {
                    context.commit("SET_REGISTRATION_IS_SUCCESS", true);
                    context.commit("SET_USER_UUID", data.data.uuid);
                    localStorage.setItem("api_key", data.data.api_key);
                    resolve(data);
                })
                .catch((error) => {
                    context.commit("SET_REGISTRATION_IS_SUCCESS", false);
                    reject(error);
                })
                .finally(() => {
                    context.commit("SET_REGISTRATION_LOADING", false);
                });
        });
    },

    STORE_UTM: (context, route) => {
        const utm = {
            utm_campaign: route.query.utm_campaign,
            utm_content: route.query.utm_content,
            utm_medium: route.query.utm_medium,
            utm_source: route.query.utm_source,
            utm_term: route.query.utm_term,
            pxlid: route.query.pxlid,
            vkid: route.query.vkid,
        };
        if (utm.utm_campaign) localStorage.setItem("utm_campaign", utm.utm_campaign);
        if (utm.utm_content) localStorage.setItem("utm_content", utm.utm_content);
        if (utm.utm_medium) localStorage.setItem("utm_medium", utm.utm_medium);
        if (utm.utm_source) localStorage.setItem("utm_source", utm.utm_source);
        if (utm.utm_term) localStorage.setItem("utm_term", utm.utm_term);
        if (utm.pxlid) localStorage.setItem("pxlid", utm.pxlid);
        if (utm.vkid) localStorage.setItem("vkid", utm.vkid);
        context.commit("SET_UTM", utm);
    },
    STORE_AFF_SUBS: (context, route) => {
        const affSubs = {
            aff_sub1: route.query.aff_sub1,
            aff_sub2: route.query.aff_sub2,
            aff_sub3: route.query.aff_sub3,
            aff_sub4: route.query.aff_sub4,
            aff_sub5: route.query.aff_sub5,
        };
        if (affSubs.aff_sub1) localStorage.setItem("aff_sub1", affSubs.aff_sub1);
        if (affSubs.aff_sub2) localStorage.setItem("aff_sub2", affSubs.aff_sub2);
        if (affSubs.aff_sub3) localStorage.setItem("aff_sub3", affSubs.aff_sub3);
        if (affSubs.aff_sub4) localStorage.setItem("aff_sub4", affSubs.aff_sub4);
        if (affSubs.aff_sub5) localStorage.setItem("aff_sub5", affSubs.aff_sub5);
        context.commit("SET_AFF_SUBS", affSubs);
    },

    SET_AUTH_TO_CREDENTIALS: (context, user) => {
        user.phone = user.phone.toString().replace(/\D+/g, "");
        context.commit("SET_USER_CREDITIONALS", user);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
